/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
  GetApiV1NotificationMobileAppSharedSelectionSummaryQueryParams,
  GetApiV1NotificationMobileAppSharedSelectionSummary401,
  GetApiV1NotificationMobileAppSharedSelectionSummary500,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedSelectionSummary.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1NotificationMobileAppSharedSelectionSummary } from "../../clients/notificationMobileAppController/getApiV1NotificationMobileAppSharedSelectionSummary.ts";

export const getApiV1NotificationMobileAppSharedSelectionSummaryQueryKey = (
  params?: GetApiV1NotificationMobileAppSharedSelectionSummaryQueryParams,
) =>
  [
    { url: "/api/v1/notification/mobile-app/shared/selection-summary" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1NotificationMobileAppSharedSelectionSummaryQueryKey =
  ReturnType<
    typeof getApiV1NotificationMobileAppSharedSelectionSummaryQueryKey
  >;

export function getApiV1NotificationMobileAppSharedSelectionSummaryQueryOptions(
  params?: GetApiV1NotificationMobileAppSharedSelectionSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1NotificationMobileAppSharedSelectionSummaryQueryKey(params);
  return queryOptions<
    GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppSharedSelectionSummary401
      | GetApiV1NotificationMobileAppSharedSelectionSummary500
    >,
    GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1NotificationMobileAppSharedSelectionSummary(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a quantidade de alunos impactados pelo filtro, a quantidade de turmas selecionadas e a quantidade de status de matrícula informados. Quando `isAllClassStudents=true`, ignora `classStudentIds` e considera todas as turmas ativas. **(Requer Authorization para autenticação)**
 * @summary Resumo da seleção de notificação (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/shared/selection-summary}
 */
export function useGetApiV1NotificationMobileAppSharedSelectionSummary<
  TData = GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
  TQueryData = GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1NotificationMobileAppSharedSelectionSummaryQueryKey,
>(
  params?: GetApiV1NotificationMobileAppSharedSelectionSummaryQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
        ResponseErrorConfig<
          | GetApiV1NotificationMobileAppSharedSelectionSummary401
          | GetApiV1NotificationMobileAppSharedSelectionSummary500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1NotificationMobileAppSharedSelectionSummaryQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1NotificationMobileAppSharedSelectionSummaryQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppSharedSelectionSummary401
      | GetApiV1NotificationMobileAppSharedSelectionSummary500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
